<template>
  <!-- 门诊专区管理 -->
  <div class="pharmacyZone">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['专区及品牌维护', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="selectedList.length == 0"
          @click="delDell"
          >批量删除</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd"
          >添加</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">专区管理：</label>
        <el-select
          placeholder="专区管理"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.prefecture"
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      @selection-change="selectionChange"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column
        align="center"
        prop="article_id"
        show-overflow-tooltip
        label="商品编号"
      >
      </el-table-column>
      <el-table-column
        prop="sub_title"
        label="商品名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="sort_id"
        label="排序"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="drug_spec"
        label="商品规格"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="price"
        label="建议零售价"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="stock_quantity"
        label="库存"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="approval_number"
        label="国药准字"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="drug_factory"
        label="生产厂家"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="add_time"
        label="添加时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 绑定商品dialog -->
    <el-dialog
      title="商品列表"
      :visible.sync="dialogVisible"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="40%"
    >
      <el-form
        :model="searchForm2"
        label-position="left"
        label-width="80px"
        :rules="formRule2"
        ref="searchForm2"
      >
        <el-form-item label="商品名称" prop="type">
          <el-select
            style="width: 100%; margin-right: 5px"
            v-model="searchForm2.type"
          >
            <el-option
              v-for="item in optionsList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称" prop="name">
          <el-input
            v-model="searchForm2.name"
            placeholder="请输入楼层名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number
            v-model="searchForm2.sort"
            :controls="false"
            style="width: 100%"
            :min="1"
            placeholder="请输入排列序号"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureModify">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "pharmacyZone",
  data() {
    return {
      /**表格数据 */
      //商品编号	商品名称	排序	商品规格	建议零售价	库存	国药准字	生产厂家	添加时间
      tableData: [
        {
          number: "商品编号",
          name: "商品名称",
          sort: "排序",
          specification: "商品规格",
          retailPrice: "建议零售价",
          repertory: "库存",
          SFDA: "国药准字",
          producer: "生产厂家",
          time: "添加时间",
        },
      ],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      selectedList: [] /**存放选中的数据 */,
      /**搜索表单 */
      searchForm: {
        name: "",
        prefecture: "1",
      },
      options: [
        {
          value: "2",
          label: "保健专区",
        },
        {
          value: "1",
          label: "药店专区",
        },
        {
          value: "0",
          label: "门诊专区",
        },
      ],
      optionsList: [
        {
          value: "2",
          label: "保健专区",
        },
        {
          value: "1",
          label: "药店专区",
        },
        {
          value: "0",
          label: "门诊专区",
        },
      ],
      dialogVisible: false,
      //商品编号	名称	规格	中包装	件装量	生产厂家	库存
      goodsList: [
        {
          number: "商品编号",
          name: "名称",
          specification: "规格",
          mediumPackage: "中包装",
          packages: "生产厂家",
          producer: "生产厂家",
          repertory: "库存",
        },
      ] /**商品列表 */,
      selectedList2: [] /**存放选中的商品数据 */,
      /**分页数据 */
      currPage2: 1,
      pageSize2: 20,
      allPage2: 0,
      /**搜索表单 */
      searchForm2: {
        type: "",
        name: "",
        sort: "",
      },
      formRule2: {
        type: "",
        name: [{ required: true, message: "请输入内容", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
    };
  },
  components: {},
  mounted() {
    this.getTableData();
  },
  methods: {
    /**获取表格数据 */
    getTableData() {
      let data = {
        type: "Pc_GetArrondiProduct",
        strWhere: this.searchForm.name,
        ArrondiType: this.searchForm.prefecture,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_Brand"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "brand/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          console.log(res);
          if (res.flag == 0) {
            console.log(res);
            this.tableData = res.data;
            this.allPage = res.recordCount;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 确定添加
    sureModify() {
      this.$refs.searchForm2.validate((valid) => {
        if (valid) {
          var json = {
            type: "Pc_SetArrondiProduct",
            article_id: this.searchForm2.type,
            sort_id: this.searchForm2.sort,
            ArrondiType: this.searchForm2.name,
          };
          var proc = "Proc_Admin_Brand"; //存储过程名
          var type = "ReturnList";
          console.log(JSON.stringify(json));
          ///加载页面数据
          this.$requestSys({
            method: "post",
            url:
              "brand/ashx/returnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(json)) +
              "&proc=" +
              proc,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        }
      });
    },
    /**获取商品数据 */
    getGoodsList() {},
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange2(val) {
      this.pageSize2 = val;
      this.getGoodsList();
    },
    /**当前页改变 */
    hanCurrChange2(val) {
      this.currPage2 = val;
      this.getGoodsList();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },

    /**点击添加商品 */
    handleAdd() {
      this.dialogVisible = true;
    },
    /**点击确定绑定 */
    submitForm() {},
    /**取消绑定 */
    clearForm() {
      this.dialogVisible = false;
    },
    // 批量删除
    delDell() {
      let idList = [];
      this.selectedList.forEach((i) => {
        idList.push(i.article_id);
      });
      idList = idList.join();
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          let data = {
            type: "PC_DelArronPro",
            strWhere: idList,
            ArrondiType: this.searchForm.prefecture,
          };
          let proc = "PC_CustomerType"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            method: "post",
            url:
              "coupon/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**selection change触发事件 */
    selectionChange2(section) {
      //存放选中的表格数据
      this.selectedList2 = section;
    },
  },
};
</script>

<style scoped>
.pharmacyZone {
  width: 100%;
  height: 100%;
}
</style>